import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-950">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500/10 text-primary-500 mb-3">
            常见问题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-3">
            你关心的，都在这里
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            关于夜猫电影院的常见疑问，快速为你解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="rounded-xl border border-background-700/30 bg-background-800/30 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
              >
                <span className="text-foreground-100 text-sm md:text-base font-medium pr-4">
                  {item.question}
                </span>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full bg-background-700/40 text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                  openIndex === i ? 'rotate-45' : ''
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`px-5 md:px-6 overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'pb-4 md:pb-5 max-h-96' : 'max-h-0'
                }`}
              >
                <p className="text-foreground-600 text-sm leading-relaxed border-t border-background-700/30 pt-4">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}